import { getContext } from '@fiverr-private/fiverr_context';
import { bigQuery } from '@fiverr-private/obs';
import { ACTION_TYPES, GROUPES, SUB_GROUPES } from '../constants';
import { getMarketplaceIntegrationBqPayload } from '../utils';

const trackLogoCardIsHovered =
    ({ projectsMap, briefId }) =>
    (cardDetails) => {
        const { isTouch, pageCtxId } = getContext();

        if (isTouch) {
            return;
        }

        const project = projectsMap[cardDetails.projectId] || {};

        bigQuery.send(
            getMarketplaceIntegrationBqPayload({
                type: 'logo_card_is_hovered',
                action: {
                    type: ACTION_TYPES.IMPRESSION,
                },
                group: GROUPES.USERS_IMRESSIONS,
                sub_group: SUB_GROUPES.CONTENT_IMPRESSION,
                gig_impression: {
                    alg: {
                        name: project.algoPool,
                    },
                    type: project.engineType,
                    listings: {
                        page_ctx_id: pageCtxId,
                    },
                },
                seller: {
                    id: project.user_id,
                },
                makers_project: {
                    id: cardDetails.projectId,
                    brief: { id: briefId },
                    variation: { id: cardDetails.variationId },
                },
                item_context: {
                    position: cardDetails.logoPosition,
                    variation_position: cardDetails.variationPosition,
                },
            })
        );
    };

export default trackLogoCardIsHovered;
